exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaBreadCrumb{background:#f8f8f8;padding:1rem;margin:0 0 1rem}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaBreadCrumb/lbaBreadCrumb.scss"],"names":[],"mappings":"AAAA,eACE,mBAAoB,AACpB,aAAc,AACd,eAAiB,CAAE","file":"lbaBreadCrumb.scss","sourcesContent":[".lbaBreadCrumb {\n  background: #f8f8f8;\n  padding: 1rem;\n  margin: 0 0 1rem; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaBreadCrumb/lbaBreadCrumb.scss
// module id = 304
// module chunks = 0